import axios from "axios";

axios.defaults.withCredentials = true;

export default {
  async getCandidatures(idFormation) {
    const response = await axios.get(
      "/api/gestion/candidatures/formation/" + idFormation
    );
    return response.data;
  },

  async getCandidaturesEtudiant() {
    const response = await axios.get("/api/etudiants/candidatures");
    return response.data;
  },
  async addCandidatureEtudiant(candidature) {
    const response = await axios.post(
      "/api/etudiants/candidatures",
      candidature
    );
    return response.data;
  },
  async getCandidatureEtudiant(idCandidature) {
    const response = await axios.get(
      "/api/etudiants/candidatures/" + idCandidature
    );
    return response.data;
  },
  async getCandidature(idCandidature) {
    const response = await axios.get(
      "/api/gestion/candidature/" + idCandidature
    );
    return response.data;
  },

  async updateCandidatureEtudiant(idCandidature, candidature) {
    const response = await axios.put(
      "/api/etudiants/candidatures/" + idCandidature,
      candidature
    );
    return response.data;
  },

  async validerCandidatureSuaio(idCandidature) {
    await axios.put("/api/suaio/validerCandidatureSuaio/" + idCandidature);
  },

  async renvoyerCandidature(idCandidature, motif) {
    await axios.put("/api/gestion/renvoyerCandidature", {
      idCandidature: idCandidature,
      motif: motif,
    });
  },

  async validerCandidatureEnseignant(idCandidature, motif) {
    await axios.put("/api/enseignant/validerCandidatureEnseignant", {
      idCandidature: idCandidature,
      motif: motif,
    });
  },
  async repentirCandidatureEnseignant(idCandidature) {
    await axios.put(
      "/api/enseignant/repentirCandidatureEnseignant/" + idCandidature
    );
  },

  async refuserCandidatureEnseignant(idCandidature, motif) {
    await axios.put("/api/enseignant/refuserCandidatureEnseignant", {
      idCandidature: idCandidature,
      motif: motif,
    });
  },
  async invaliderCandidature(idCandidature, motif) {
    await axios.put("/api/gestion/invaliderCandidature", {
      idCandidature: idCandidature,
      motif: motif,
    });
  },
  async addAndValidateCandidatureEtudiant(candidature) {
    const response = await axios.post(
      "/api/etudiants/candidatures/validation",
      candidature
    );
    return response.data;
  },
  async updateAndValidateCandidatureEtudiant(idCandidature, candidature) {
    const response = await axios.put(
      "/api/etudiants/candidatures/" + idCandidature + "/validation",
      candidature
    );
    return response.data;
  },
  async getCandidaturesEtudiantPourGestion(idEtudiant) {
    const response = await axios.get(
      "/api/gestion/" + idEtudiant + "/candidatures"
    );
    return response.data;
  },
  async finaliserCandidature(idCandidature) {
    const response = await axios.put(
      "/api/scolarite/finaliserCandidature/" + idCandidature
    );
    return response.data;
  },
  async confirmerCandidature(idCandidature) {
    const response = await axios.put(
      "/api/etudiants/candidatures/" + idCandidature + "/confirmer"
    );
    return response.data;
  },
  async desistementCandidature(idCandidature) {
    const response = await axios.put(
      "/api/etudiants/candidatures/" + idCandidature + "/desistement"
    );
    return response.data;
  },
  async getCsvFile(critere, id) {
    const url = `/api/gestion/csv/${critere}/${id}`;
    const response = await axios.get(url);
    return response.data;
  },
  async getEtatsResetCandidature(idCandidature) {
    const response = await axios.get(
      "/api/admin/candidatures/" + idCandidature + "/etatsReset"
    );
    return response.data;
  },
  async resetCandidature(idCandidature, etatReset) {
    const response = await axios.put(
      "/api/admin/candidatures/" + idCandidature + "/reset",
      etatReset
    );
    return response.data;
  },
  async getCandidatureEtudiantPourGestion(idEtudiant, idCandidature) {
    const response = await axios.get(
      "/api/gestion/" + idEtudiant + "/candidatures/" + idCandidature
    );
    return response.data;
  },
  async repentirCandidatureSuaio(idCandidature) {
    await axios.put("/api/suaio/repentirCandidatureSuaio/" + idCandidature);
  },
};
